import styled from "styled-components";

import { fontSizes } from "../../../shared/styles/typography";

export const SelectionHeader = styled.div`
  padding: 16px;
  padding-bottom: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CategoriesEntry = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #e8eaf0;
  background: #fff;
  color: #1e293b;
  font-size: ${fontSizes.base}px;
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  &:active {
    opacity: 0.92;
  }
`;

export const SelectionCard = styled.div`
  background: #5f33e1;
  border: 2px solid #4a2bb8;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

  h2 {
    font-size: ${fontSizes.base}px;
    font-weight: var(--font-weight-semibold);
    margin: 0;
    color: #ffffff;
    letter-spacing: 0.5px;
  }

  p {
    font-size: ${fontSizes.sm}px;
    font-weight: 600;
    color: #ffffff;
    opacity: 0.9;
    margin: 0;
    letter-spacing: 0.3px;
  }
`;

export const InfoTooltip = styled.div`
  margin-top: 8px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  color: #ffffff;

  span {
    font-size: ${fontSizes.sm}px;
    font-weight: 500;
    opacity: 0.85;
    text-align: left;
    line-height: 1.2;
  }
`;

export const LetterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 16px;
  margin-bottom: 40px;
`;

export const LetterCard = styled.button`
  aspect-ratio: 1;
  background: #5f33e1;
  border: 3px solid #4a2bb8;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  cursor: pointer;
  transition: transform 0.1s;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);

  &:active {
    transform: scale(0.95);
  }

  span {
    font-size: ${fontSizes["3xl"]}px;
    font-weight: var(--font-weight-semibold);
    letter-spacing: 1px;
  }
`;

export const LibrasModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 16px 0;

  h3 {
    font-size: ${fontSizes.base}px;
    font-weight: var(--font-weight-semibold);
    color: #1e293b;
    margin: 0;
    letter-spacing: 0.5px;
  }

  p {
    font-size: ${fontSizes.sm}px;
    font-weight: 600;
    color: #1e293b;
    opacity: 0.8;
    margin: 0;
  }

  .dactylology-modal-btn {
    margin-top: 4px;
    padding: 12px 20px;
    border-radius: 12px;
    border: none;
    background: #5f33e1;
    color: #fff;
    font-weight: var(--font-weight-semibold);
    cursor: pointer;
    font-size: ${fontSizes.base}px;
    width: 100%;
    max-width: 280px;
  }

  .dactylology-modal-btn:active {
    opacity: 0.92;
  }
`;

export const LibrasCircle = styled.div`
  width: 180px;
  height: 180px;
  background: #5f33e1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid #5f33e1;

  .libras-font {
    font-family: "Libras2020", sans-serif;
    font-size: 6rem;
    color: #ffffff;
    text-align: center;
  }
`;
